import validate from "/app/node_modules/.pnpm/nuxt@3.17.2_@biomejs+biome@1.9.4_@capacitor+preferences@6.0.3_@capacitor+core@7.2.0__@parcel+_iakbkifgkcedzfagilq4xbpkf4/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects301_45global from "/app/apps/website/app/middleware/redirects301.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.2_@biomejs+biome@1.9.4_@capacitor+preferences@6.0.3_@capacitor+core@7.2.0__@parcel+_iakbkifgkcedzfagilq4xbpkf4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects301_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}